import React from 'react';

export default function ImageElement({ 
  src, 
  position, 
  size, 
  style, 
  scale = 1,
  messengerStyle = false,
  hasBorder,
  borderColor,
  borderWidth,
  borderStyle,
  borderRadius,
  borderOpacity,
}) {
  if (!src) return null;

  const showBorder = hasBorder !== undefined ? hasBorder : true;
  const bColor = borderColor || '#ffffff';
  const bWidth = borderWidth !== undefined ? Number(borderWidth) : 8;
  const bStyle = borderStyle || 'solid';
  const bRadius = borderRadius !== undefined ? Number(borderRadius) : 8;
  const bOpacity = borderOpacity !== undefined ? Number(borderOpacity) / 100 : 1;

  const scaledWidth = size.width * scale;
  const scaledHeight = size.height * scale;

  if (messengerStyle) {
    return (
      <img
        src={src}
        alt=""
        style={{
          position: 'absolute',
          left: `${position.x * scale}px`,
          top: `${position.y * scale}px`,
          width: `${scaledWidth}px`,
          height: `${scaledHeight}px`,
          objectFit: style?.objectFit || 'contain',
          borderRadius: '12px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
          margin: '4px 0',
        }}
        className="p-1"
      />
    );
  }

  if (!showBorder) {
    return (
      <img
        src={src}
        alt=""
        style={{
          position: 'absolute',
          left: `${position.x * scale}px`,
          top: `${position.y * scale}px`,
          width: `${scaledWidth}px`,
          height: `${scaledHeight}px`,
          objectFit: style?.objectFit || 'contain',
          borderRadius: `${bRadius}px`,
        }}
      />
    );
  }

  const isSolid = bStyle === 'solid';

  return (
    <div
      style={{
        position: 'absolute',
        left: `${position.x * scale}px`,
        top: `${position.y * scale}px`,
        width: `${scaledWidth}px`,
        height: `${scaledHeight}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: bOpacity,
      }}
    >
      {/* Border wrapper - applies border directly around the image */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: `${bRadius}px`,
          ...(isSolid
            ? { backgroundColor: bColor, padding: `${bWidth}px` }
            : { borderWidth: `${bWidth}px`, borderStyle: bStyle, borderColor: bColor }),
        }}
      >
        <img
          src={src}
          alt=""
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: style?.objectFit || 'contain',
            objectPosition: 'center',
            display: 'block',
            borderRadius: `${Math.max(0, bRadius - 2)}px`,
          }}
        />
      </div>
    </div>
  );
}